// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topbar {
    width: 100%;
    height: 4rem;
    display: flex;
    flex-direction: row;
    flex-grow: 0;
    margin-bottom: 0.5rem;
}
.topbar div {
    background-color: rgba(206, 124, 0, 0.4); /* Border color */
    backdrop-filter: blur(2px);
    border: 3px solid rgb(206, 134, 0);
    border-radius: 5px;
    margin-right: 5px;
}
.topbar h1 {
    height: 100%;
    margin: 10px 20px 10px 23px;
    font-size: 2rem;
}

.topbar_big {
    height: 100%;
}
.topbar_small {
    height: 50%;
}

.topbar_apps {
    height: 50%;
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    padding-left: 10px;
}
.topbar_apps button {
    background-color: rgba(0, 0, 0, 0);
    color: white;
    border: none;
    padding: 0 10px 0 10px;
}
.topbar_apps button:hover {
    background-color: rgba(0, 0, 0, 0.308);
}`, "",{"version":3,"sources":["webpack://./src/general_assets/topbar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,wCAAwC,EAAE,iBAAiB;IAC3D,0BAA0B;IAC1B,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,sCAAsC;AAC1C","sourcesContent":[".topbar {\r\n    width: 100%;\r\n    height: 4rem;\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-grow: 0;\r\n    margin-bottom: 0.5rem;\r\n}\r\n.topbar div {\r\n    background-color: rgba(206, 124, 0, 0.4); /* Border color */\r\n    backdrop-filter: blur(2px);\r\n    border: 3px solid rgb(206, 134, 0);\r\n    border-radius: 5px;\r\n    margin-right: 5px;\r\n}\r\n.topbar h1 {\r\n    height: 100%;\r\n    margin: 10px 20px 10px 23px;\r\n    font-size: 2rem;\r\n}\r\n\r\n.topbar_big {\r\n    height: 100%;\r\n}\r\n.topbar_small {\r\n    height: 50%;\r\n}\r\n\r\n.topbar_apps {\r\n    height: 50%;\r\n    flex-grow: 1;\r\n    display: flex;\r\n    flex-direction: row;\r\n    padding-left: 10px;\r\n}\r\n.topbar_apps button {\r\n    background-color: rgba(0, 0, 0, 0);\r\n    color: white;\r\n    border: none;\r\n    padding: 0 10px 0 10px;\r\n}\r\n.topbar_apps button:hover {\r\n    background-color: rgba(0, 0, 0, 0.308);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
